import {MouseEvent} from 'react';

import {AppNotification, NotificationType} from '../types/notifications.types';
import {NotificationsPanel, NotificationsPopover as NotificationsPopoverRoot} from './notifications.styles';
import {NotificationsHeader} from './notifications-header';
import {NotificationDetails} from './notification-details';
import {NotificationsList} from './notification-list';

type ViewMode = 'list' | 'details';

interface NotificationsPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onOpenBulkActions: (event: MouseEvent<HTMLElement>) => void;
  onOpenNotificationActions: (event: MouseEvent<HTMLElement>, id: string) => void;
  selectedTab: NotificationType;
  newNotificationsCount: number;
  notifications: AppNotification[];
  loading: boolean;
  error: unknown;
  onSelectTab: (selectedTab: NotificationType) => void;
  onRetry: VoidFunction;
  viewMode: ViewMode;
  selectedNotification: AppNotification | null;
  onOpenNotificationDetails: (id: string) => void;
  onBackToList: VoidFunction;
}

export const NotificationsPopover = ({
  anchorEl,
  open,
  onClose,
  onOpenBulkActions,
  onOpenNotificationActions,
  selectedTab,
  newNotificationsCount,
  notifications,
  loading,
  error,
  onSelectTab,
  onRetry,
  viewMode,
  selectedNotification,
  onOpenNotificationDetails,
  onBackToList,
}: NotificationsPopoverProps) => {
  return (
    <NotificationsPopoverRoot
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <NotificationsPanel>
        {viewMode === 'details' && selectedNotification ? (
          <NotificationDetails
            notification={selectedNotification}
            onBack={onBackToList}
            onOpenNotificationActions={onOpenNotificationActions}
          />
        ) : (
          <>
            <NotificationsHeader
              onOpenBulkActions={onOpenBulkActions}
              selectedTab={selectedTab}
              newNotificationsCount={newNotificationsCount}
              onSelectTab={onSelectTab}
            />
            <NotificationsList
              notifications={notifications}
              loading={loading}
              error={error}
              onRetry={onRetry}
              onOpenNotificationActions={onOpenNotificationActions}
              onOpenNotificationDetails={onOpenNotificationDetails}
            />
          </>
        )}
      </NotificationsPanel>
    </NotificationsPopoverRoot>
  );
};
